exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-complete-enter, .list-complete-leave-to {\n    opacity: 0;\n}\n.list-complete-leave {\n    -webkit-transition: opacity .5s;\n    transition: opacity .5s;\n}\n.list-complete-enter-to {\n    -webkit-transition: opacity 1.5s;\n    transition: opacity 1.5s;\n}\n.k-custom-width .k-sort-select-choices {\n    min-width: 170px !important;\n}\n\n", ""]);

// exports
